import { render, staticRenderFns } from "./MakerProjectFeed.vue?vue&type=template&id=79c4f193&scoped=true&"
import script from "./MakerProjectFeed.vue?vue&type=script&lang=js&"
export * from "./MakerProjectFeed.vue?vue&type=script&lang=js&"
import style0 from "./MakerProjectFeed.vue?vue&type=style&index=0&id=79c4f193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4f193",
  null
  
)

export default component.exports